import { CommonOption, NumberOption } from "types/common";

// Resolve a stored value back to its select option; string values compare
// case-insensitively because the API and the option lists disagree on
// casing for some codes (e.g. locale "ru" vs option "RU").
export const getSelectValue = (value: string, options: CommonOption[]) => {
  return options.find(
    (option) => option.value.toLowerCase() === value?.toLowerCase(),
  );
};

export const getSelectNumberValue = (
  value: number,
  options: NumberOption[],
) => {
  return options.find((option) => option.value === value);
};
